<template>
    <div>
        <div
            v-popselect:reply_waterfall_add_btn.click
            class="waterfall-add-msg"
        >
            新建图文消息
        </div>
        <v-popselect
            ref="reply_waterfall_add_btn"
            :options="options"
            clazz="editor-pop-select"
        >
            <template
                slot="item"
                slot-scope="prop"
            >
                <a
                    :class="prop.item.className"
                    :href="prop.item.url"
                    target="_blank"
                    class="waterfall-add-msg-item"
                >{{
                    prop.item.text
                }}</a>
            </template>
        </v-popselect>
    </div>
</template>

<script>
import axios from 'axios';

const { hostname } = window.location;
const getCreateMaterialUrl = `/mp/imgTxtMaterial/urlXM?redirect_url=https://${hostname}/mp/qf/edit`;

export default {
    name: 'WaterfallAdd',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [
                {
                    className: 'editor-link',
                    text: '系统编辑器',
                    url: '/mp/imgTxtMaterial/Single',
                },
            ],
            hasFetchXMUrl: false,
        };
    },
    watch: {
        // @2023-02-20 前端全量屏蔽秀米编辑器入口 https://tapd.woa.com/TencentNewBiz/prong/stories/view/1010109441882186813
        // show(newValue) {
        //     newValue && !this.hasFetchXMUrl && this.fetchXMUrl();
        // }
    },
    methods: {
        fetchXMUrl() {
            this.hasFetchXMUrl = true;
            axios({
                method: 'get',
                url: getCreateMaterialUrl,
            }).then((res) => {
                const url = res && res.url;
                url
                    && this.options.unshift({
                        className: 'xiumi-link',
                        text: '秀米编辑器',
                        url,
                    });
            });
        },
    },
};
</script>

<style>
.waterfall-add-msg {
    padding-left: 25px;
    font-size: 16px;
    line-height: 20px;
    text-align: right;
    color: #1e2330;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUeIzAeIzAeIzAeIzDdizy3AAAAA3RSTlMAw8SGqEb6AAAAIElEQVQI12NgYHRgYGBgPoCHqP///y+I+EdAHQNjAwMAkvsQ3Mkw/qYAAAAASUVORK5CYII=')
        0 50% no-repeat;
    cursor: pointer;
}

.waterfall-add-msg:hover {
    color: #0067ed;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAZ+0AZ+0AZ+0AZ+3NQw2EAAAAA3RSTlMAw8SGqEb6AAAAIElEQVQI12NgYHRgYGBgPoCHqP///y+I+EdAHQNjAwMAkvsQ3Mkw/qYAAAAASUVORK5CYII=');
}

.waterfall-add-msg-item {
    padding: 0 15px 0 45px;
    line-height: 40px;
    white-space: nowrap;
    color: #1e2330;
    background: 15px 50% no-repeat;
}

.waterfall-add-msg-item:hover {
    background-color: #f5fafe;
}

.waterfall-add-msg-item.editor-link {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAElBMVEUAAAAeIzAeIzAeIzAeIzAyNDu0IscPAAAABHRSTlMA5kpJG2qUMwAAAEJJREFUCNdjQALMIi5g4GjAwOgCBQIMLA5gSSCNymQNBYIADGYAECIzodpYA6DaCDNZgWZhMjHdgOxIJpjTFZD8AwDrLxikDSwhwQAAAABJRU5ErkJggg==');
}

.waterfall-add-msg-item.xiumi-link {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAACW1BMVEUAAABctrDyPFuA+t9AuKM8yrdW37BBopyYZIhy2NPmk2PNVlabH04Y2Mx59NP7w0ksjplExqVCwaMoS27/JHH8xUj/YmLtRzt59NR59NJ26N5Gz6hFv6v7wErlNCp/7tfyPlgvh6HyQFktpLdBvqMy17f6sE7/nkZdr4xfyLXhNXnYNHT/tE3/QUn7v0rPXYfZQEl69NPtcHU5epkY0tCM1ca7NUz/PSb7vEsqq5862Lc/lJT/InLzQ1TKP3n2T0rrRT/9lkxI1qo2boFN3q9Bj5DyQ1L3VlB37OA4qpozmJTyQVn6r0x97tZ85NNxzsptvb1Vs7c5nrBYo6hNmqdCkZs6k5Y2kJTyPlz4h1HQalH4mU//REzLO0v/YTeI/+uH/OF//99V2d1v3dqF5ddH0NZ68tV48dRjzc141Mty3ckZ5cZ3ysZuwcAmtsA2r79iv744tr5Cz70trbtAwblntbgfkbhhuLVer7VZprJyrbFkrbBhs69Mpq0jnatZrKkoi6lAtahIpahHnqhQqKdBsqYueaVJp6NToKOirp9Gqp49u50lnJ0wkJuzno4fXI05fonGUomAkIXLQISzP4C6NIAvaX9vdn5rjn0pY3nRT3jfNXjrYXbvZ3QtWHTRM3PQJXOjJnL8FXKtH270WWu4IGsdOmHod1z9L1r/TVjySFj8Slf9VFX2PFX/bVP4m1G0N1G5K1H1eVDRYVD0c0/mbE/+YU/pfU2bGU35oEz/hEv9d0v/jEr/lknAK0n/xUjgT0j/vEfUNkf/rUbiREX/SUP/cz3iOjnzPCzyRBx3AAAASXRSTlMA++lWKv79/f38+vf39PLy7+3l5OLg39vUzcbEwMC/vry0s62tqZycl5GKh4J3dXJybmtpZ2BfWlhSUU1NSkRDPTo2MicdHA4J4jnopwAAAR9JREFUGNNjIAUwS/BJGkKYFrL8onpgsfjE9DRfeQ8gU83Hx+fgfh0gi7EjK8HXz0+KgUF9fXT04Z1Rm4GCwsvm1aRk+iebOu6JjNy7fcMOHqCg84RpM+tzcv05uY5t2rV1475YM5Ch1uxh4YwBAUmdcbu3xB46YgCxk0WmsbW8tCBjedyB4+IOcFdZqbJWVKf2nZAzR3arPkdtYGDVDA0kIRuRRSsmFQZXFmXzmsDEtGYvmLwuKqg5JLgkr1gZIqY9f+nUuduOTq8LDW3JL2tQBInZLV44Zc6aVTHcAr3hYe1Bbf3GQEGjibOWrPb2jrF37fHy8upqCtEECrqLrVwbEeGty8Bg6QkE3WwuIP1uSkxMCrZgX6gICUo7kRLsAIIoVy/ezMglAAAAAElFTkSuQmCC');
}

.editor-pop-select {
    z-index: 99999 !important;
    margin-top: 10px;
    margin-left: 4px;
}
</style>
